import React from 'react';
import Translate from 'react-translate-component';
import moment from 'moment';

import { DATE_FORMATS } from 'constants/dateFormats';

export const Sent = ({ value }) => {
    if (!value) return null;

    const timestamp = moment(value, DATE_FORMATS.format).toDate().getTime();
    const days = (moment().diff(moment(timestamp), 'days') === 0)
        ? <Translate content="common.lessThanDay" />
        : moment(timestamp).fromNow(true);

    return (
        <span className="time-passed-block">
            <span className="date">{days}</span>
            { " " }
            <Translate content="common.ago" component="span" />
        </span>
    );
}
